import {BaseLinkParams} from "../../../infrastructure/models/link/base-link-params";
import {DASHBOARD} from "../../dashboard-container/dashboard-container.consts";
import sportTypes from "../../../core/app/consts/sport-types";
import {SPORT_TYPES} from "../../../core/app/consts";
import {addDays, endOfDay, isAfter, isBefore, isTomorrow, isYesterday, startOfDay, subDays} from 'date-fns';

export class AllScoresLinkParams extends BaseLinkParams {
  sportName: String;
  filter: String;

  constructor(sportName: String, filter: String) {
    super();

    this.sportName = this._calcSportName(sportName, filter);
    this.filter = this._calcFilter(sportName, filter);
  }

  _calcFilter(sportName: String, filter: String) {
    const sportNameIsFilter = DASHBOARD.FILTERS.live === sportName || DASHBOARD.FILTERS.dateRegEx.test(sportName);
    let currentFilter = filter || '';

    if(sportNameIsFilter && !filter) {
      currentFilter = sportName || '';
    }

    if(this.isWhereToWatch(sportName)) {
      currentFilter = ''
    } else if(isTomorrow(new Date(filter).toLocaleString('en', { timeZone: 'UTC' }))) {
      currentFilter = DASHBOARD.FILTERS.tomorrow
    } else if(isYesterday(new Date(filter).toLocaleString('en', { timeZone: 'UTC' }))) {
      currentFilter = DASHBOARD.FILTERS.yesterday
    } else if(this.isBeforeYesterday(filter)){
      currentFilter = DASHBOARD.FILTERS.results;
    } else if(this.isAfterTomorrow(filter)) {
      currentFilter = DASHBOARD.FILTERS.fixtures;
    }

    return currentFilter;
  }

  _calcSportName(sportName: String, filter: String) {
    const hasFilter = DASHBOARD.FILTERS.live === filter || DASHBOARD.FILTERS.dateRegEx.test(filter);
    const football = sportTypes.sports.find((sport) => sport.id === SPORT_TYPES.football);
    const isFootball: Boolean = sportName === football.nameForURL;

    return !isFootball ? sportName : hasFilter ? sportName : '';
  }

  isWhereToWatch(sportName: String) {
    const onTv = sportTypes.sports.find((sport) => sport.id === SPORT_TYPES.onTv);
    const isWhereToWatch: Boolean = sportName === onTv.nameForURL;

    return isWhereToWatch
  }

  isBeforeYesterday(filter) {
    const date = new Date(filter).toLocaleString('en', { timeZone: 'UTC' });
    return isBefore(date, subDays(startOfDay(new Date()), 1));
  }

  isAfterTomorrow(filter) {
    const date = new Date(filter).toLocaleString('en', { timeZone: 'UTC' });

    return isAfter(date, addDays(endOfDay(new Date()), 1));
  }
}